"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _keymaster = _interopRequireDefault(require("keymaster"));

// pass all events, implement custom scopes filtering
_keymaster.default.filter = function (e) {
  return true;
}; // keymaster doesn't support remove specific listener (https://github.com/madrobby/keymaster/pull/133)
// so use proxy class to store those listeners


var Listeners =
/*#__PURE__*/
function () {
  function Listeners() {
    var _this = this;

    (0, _classCallCheck2.default)(this, Listeners);
    (0, _defineProperty2.default)(this, "binds", {});
    (0, _defineProperty2.default)(this, "inputScopeRegex", /^(INPUT|TEXTAREA|SELECT)$/);
    (0, _defineProperty2.default)(this, "handle", function (event, handler) {
      var shortcut = handler.shortcut;

      if (!_this.binds.hasOwnProperty(shortcut) || event.cancelBubble) {
        return;
      }

      var tagName = (event.target || event.srcElement).tagName;
      var scope = _this.inputScopeRegex.test(tagName) ? 'input' : 'default';

      _this.binds[shortcut].find(function (item) {
        if (scope === item.scope || item.scope === 'all') {
          item.listener(event, handler);
        }

        return event.cancelBubble;
      });

      event.stopPropagation();
    });
  }

  (0, _createClass2.default)(Listeners, [{
    key: "add",
    value: function add(shortcut, scope, listener) {
      if (!this.binds.hasOwnProperty(shortcut)) {
        this.binds[shortcut] = [];
        (0, _keymaster.default)(shortcut, this.handle);
      }

      this.binds[shortcut].unshift({
        scope: scope,
        listener: listener
      });
    }
  }, {
    key: "remove",
    value: function remove(shortcut, scope, listener) {
      if (!this.binds.hasOwnProperty(shortcut)) {
        return;
      }

      this.binds[shortcut] = this.binds[shortcut].filter(function (item) {
        return item.listener !== listener;
      });

      if (this.binds[shortcut].length === 0) {
        delete this.binds[shortcut];

        _keymaster.default.unbind(shortcut);
      }
    }
  }]);
  return Listeners;
}();

var listeners = new Listeners();

var Hotkey =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Hotkey, _React$Component);

  function Hotkey() {
    var _getPrototypeOf2;

    var _this2;

    (0, _classCallCheck2.default)(this, Hotkey);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this2 = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Hotkey)).call.apply(_getPrototypeOf2, [this].concat(_args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this2)), "handle", function () {
      var _this2$props;

      return _this2.props.action && (_this2$props = _this2.props).action.apply(_this2$props, arguments);
    });
    return _this2;
  }

  (0, _createClass2.default)(Hotkey, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      listeners.add(this.props.shortcut, this.props.scope, this.handle);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      listeners.remove(this.props.shortcut, this.props.scope, this.handle);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Hotkey;
}(_react.default.Component);

exports.default = Hotkey;
(0, _defineProperty2.default)(Hotkey, "defaultProps", {
  scope: 'default'
});
Hotkey.propTypes = process.env.NODE_ENV !== "production" ? {
  shortcut: _propTypes.default.string.isRequired,
  action: _propTypes.default.func.isRequired,
  scope: _propTypes.default.oneOf(['all', 'default', 'input'])
} : {};